module.exports = __webpack_public_path__ + "static/media/holidayNew.80d4392a.png";